/**
 * Semantic accent keys for admin UI colorization.
 * CSS maps each key via [data-accent="…"] → --ui-accent.
 */
export const UI_ACCENT = {
  dashboard: "dashboard",
  students: "students",
  teachers: "teachers",
  guardians: "guardians",
  affiliates: "affiliates",
  inactive: "inactive",
  notes: "notes",
  reports: "reports",
  feeds: "feeds",
  todos: "todos",
  settings: "settings",
  activity: "activity",
  gallery: "gallery",
  training: "training",
  topics: "topics",
};

const PATH_ACCENTS = {
  "/dashboard": UI_ACCENT.dashboard,
  "/feeds": UI_ACCENT.feeds,
  "/student-reports": UI_ACCENT.reports,
  "/activity-logs": UI_ACCENT.activity,
  "/clients": UI_ACCENT.guardians,
  "/associates": UI_ACCENT.affiliates,
  "/subjects": UI_ACCENT.affiliates,
  "/students": UI_ACCENT.students,
  "/teachers": UI_ACCENT.teachers,
  "/lesson-books": UI_ACCENT.gallery,
  "/training-lesson": UI_ACCENT.training,
  "/islamic-topics": UI_ACCENT.topics,
  "/personal-notes": UI_ACCENT.notes,
  "/to-do-lists": UI_ACCENT.todos,
};

const KEY_ALIASES = {
  clients: UI_ACCENT.guardians,
  associates: UI_ACCENT.affiliates,
  affiliates: UI_ACCENT.affiliates,
  inactive: UI_ACCENT.inactive,
  "my-notes": UI_ACCENT.notes,
  my_notes: UI_ACCENT.notes,
  "activity-logs": UI_ACCENT.activity,
  "islamic-topics": UI_ACCENT.topics,
  "lesson-books": UI_ACCENT.gallery,
  "training-lesson": UI_ACCENT.training,
  "student-reports": UI_ACCENT.reports,
  "personal-notes": UI_ACCENT.notes,
  "to-do-lists": UI_ACCENT.todos,
};

/** Resolve a config key or route path to a known accent (falls back to theme via CSS). */
export function resolveUiAccent(key) {
  if (!key) return undefined;
  const raw = String(key).trim();
  if (PATH_ACCENTS[raw]) return PATH_ACCENTS[raw];

  const normalized = raw.toLowerCase().replace(/_/g, "-").replace(/^\//, "");
  if (PATH_ACCENTS[`/${normalized}`]) return PATH_ACCENTS[`/${normalized}`];
  if (KEY_ALIASES[normalized] || KEY_ALIASES[raw]) {
    return KEY_ALIASES[normalized] || KEY_ALIASES[raw];
  }
  if (Object.values(UI_ACCENT).includes(normalized)) return normalized;
  if (Object.values(UI_ACCENT).includes(raw)) return raw;
  return undefined;
}
